<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>

    <!-- ===== หัวข้อ / ฟอร์มค้นหา ===== -->
    <div class="card mb-1">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <h4 class="mb-0">
            <span class="text-muted">AutoPeer /</span>
            <span class="ml-1 font-weight-bold">Credit Transaction</span>
          </h4>
        </div>

        <div class="row">
          <!-- Username -->
          <!-- <div class="col-md-3">
            <div class="form-group">
              <label>Username</label>
              <input
                v-model="filters.username"
                type="text"
                class="form-control"
                placeholder="Username"
                @keyup.enter="getCreditReport"
              >
            </div>
          </div> -->

          <!-- Type -->
          <div class="col-md-2">
            <div class="form-group">
              <label>Type</label>
              <b-form-select
                v-model="filters.type"
                :options="typeOptions"
              />
            </div>
          </div>

          <!-- Start Date -->
          <div class="col-md-2">
            <div class="form-group">
              <label>Start Date</label>
              <flat-pickr
                v-model="filters.startDate"
                class="form-control"
                :config="datePickerConfig"
                placeholder="เลือกวันที่เริ่มต้น"
              />
            </div>
          </div>

          <!-- Start Time -->
          <!-- <div class="col-md-2">
            <div class="form-group">
              <label>Start Time</label>
              <flat-pickr
                v-model="filters.startTime"
                class="form-control"
                :config="timePickerConfig"
                placeholder="เวลาเริ่มต้น"
              />
            </div>
          </div> -->

          <!-- End Date -->
          <div class="col-md-2">
            <div class="form-group">
              <label>End Date</label>
              <flat-pickr
                v-model="filters.endDate"
                class="form-control"
                :config="datePickerConfig"
                placeholder="เลือกวันที่สิ้นสุด"
              />
            </div>
          </div>

          <!-- End Time -->
          <!-- <div class="col-md-2">
            <div class="form-group">
              <label>End Time</label>
              <flat-pickr
                v-model="filters.endTime"
                class="form-control"
                :config="timePickerConfig"
                placeholder="เวลาสิ้นสุด"
              />
            </div>
          </div> -->

          <!-- Auto Refresh + ปุ่ม -->
          <div class="col-md-3 d-flex align-items-center mt-1">
            <b-form-checkbox
              v-model="autoRefresh"
              switch
            >
              Auto Refresh
            </b-form-checkbox>
          </div>
          <div class="col-md-3 d-flex align-items-center mt-1">
            <button
              class="btn btn-outline-danger mr-1"
              type="button"
              @click="onClear"
            >
              Clear
            </button>
            <button
              class="btn btn-success"
              type="button"
              @click="getCreditReport"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== Summary Bar ===== -->
    <!-- <div class="card mb-1">
      <div class="card-body">
        <div class="row text-center">
          <div class="col-md-4 col-12 mb-1">
            <div class="summary-box bg-light">
              <div class="summary-title">
                Credit Balance
              </div>
              <div class="summary-value">
                {{ formatNumber(summary.creditBalance) }}
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12 mb-1">
            <div class="summary-box bg-light">
              <div class="summary-title">
                Withdraw
              </div>
              <div class="summary-value text-danger">
                {{ formatNumber(summary.totalWithdraw) }}
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12 mb-1">
            <div class="summary-box bg-light">
              <div class="summary-title">
                Deposit
              </div>
              <div class="summary-value text-success">
                {{ formatNumber(summary.totalDeposit) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- ===== ตารางรายงาน ===== -->
    <b-card no-body>
      <b-table
        small
        striped
        hover
        responsive
        show-empty
        class="position-relative"
        :per-page="perPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @sort-changed="getCreditReport"
      >
        <!-- running index -->
        <template #cell(index)="data">
          {{ perPage * (currentPage - 1) + (data.index + 1) }}
        </template>

        <!-- Transaction Type badge -->
        <template #cell(transactionType)="data">
          <span
            class="badge"
            :class="{
              'badge-success': data.item.transactionType === 'DEPOSIT',
              'badge-danger': data.item.transactionType === 'WITHDRAW',
              'badge-secondary': !['DEPOSIT', 'WITHDRAW'].includes(data.item.transactionType),
            }"
          >
            {{ data.item.transactionType || '-' }}
          </span>
        </template>

        <!-- Status badge -->
        <template #cell(status)="data">
          <span
            class="badge"
            :class="{
              'badge-success': data.item.status === 'SUCCESS',
              'badge-warning': data.item.status === 'PENDING',
              'badge-danger': data.item.status === 'FAILED',
              'badge-secondary': !['SUCCESS', 'PENDING', 'FAILED'].includes(data.item.status),
            }"
          >
            {{ data.item.status || '-' }}
          </span>
        </template>

        <!-- Amount / Fee / Net / Credit Before/After -->
        <template #cell(amount)="data">
          {{ formatNumber(data.item.amount) }}
        </template>
        <template #cell(fee)="data">
          {{ formatNumber(data.item.fee) }}
        </template>
        <template #cell(netAmount)="data">
          {{ formatNumber(data.item.netAmount) }}
        </template>
        <template #cell(creditBefore)="data">
          {{ formatNumber(data.item.creditBefore) }}
        </template>
        <template #cell(creditAfter)="data">
          {{ formatNumber(data.item.creditAfter) }}
        </template>

        <!-- Create Date -->
        <template #cell(createDate)="data">
          {{ formatDateTime(data.item.createDate) }}
        </template>

        <template #empty>
          <div class="p-2 text-center">
            <img
              src="/box.png"
              alt="empty"
              height="40"
            >
            ไม่พบข้อมูล
          </div>
        </template>
      </b-table>

      <!-- ===== Pagination / Per Page ===== -->
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <b-form-group
          label="Per Page"
          label-cols="8"
          label-align="left"
          label-size="sm"
          label-for="perPageSelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            :options="pageOptions"
            @change="getCreditReport"
          />
        </b-form-group>

        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @input="getCreditReport"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import moment from 'moment-timezone'
import flatPickr from 'vue-flatpickr-component'
import {
  BOverlay,
  BIconController,
  BCard,
  BCardBody,
  BTable,
  BFormGroup,
  BFormSelect,
  BPagination,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'AutoPeerCreditReport',
  components: {
    flatPickr,
    BOverlay,
    BIconController,
    BCard,
    BCardBody,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    const today = moment().tz('Asia/Bangkok')

    return {
      show: false,

      // summary
      summary: {
        creditBalance: 0,
        totalWithdraw: 0,
        totalDeposit: 0,
      },

      // filter
      filters: {
        username: '',
        type: '',
        startDate: today.format('YYYY-MM-DD'),
        startTime: '00:00',
        endDate: today.format('YYYY-MM-DD'),
        endTime: '23:59',
      },
      typeOptions: [
        { value: '', text: 'ทั้งหมด' },
        { value: 'WITHDRAW', text: 'Withdraw' },
        { value: 'DEPOSIT', text: 'Deposit' },
      ],
      datePickerConfig: {
        enableTime: false,
        dateFormat: 'Y-m-d',
      },
      timePickerConfig: {
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        dateFormat: 'H:i',
      },

      // table / pagination
      items: [],
      fields: [
        { key: 'index', label: 'No.', class: 'text-center' },
        { key: 'username', label: 'username' },

        { key: 'type', label: 'ประเภทธุรกรรม' },

        { key: 'beforeWallet', label: 'ยอดก่อนหน้า', class: 'text-right' },
        { key: 'wallet', label: 'จำนวนเงิน', class: 'text-right' },
        { key: 'fee', label: 'ค่าธรรมเนียม', class: 'text-right' },
        { key: 'netWallet', label: 'ยอดสุทธิ', class: 'text-right' },
        { key: 'afterWallet', label: 'ยอดคงเหลือ', class: 'text-right' },

        { key: 'createdBy', label: 'ทำรายการโดย' },
        {
          key: 'createdDate',
          label: 'วันที่ทำรายการ',
          sortable: true,
          formatter: v => this.formatDate(v), // ใช้ moment ไทยที่คุณทำไว้
        },
      ],

      perPage: 20,
      pageOptions: [10, 20, 50, 100],
      totalRows: 0,
      currentPage: 1,
      sortBy: 'createDate',
      sortDesc: true,
      sortDirection: 'desc',

      autoRefresh: false,
      refreshInterval: null,
    }
  },
  created() {
    // auto refresh ทุก 60 วินาที (ถ้าเปิด switch)
    this.refreshInterval = setInterval(() => {
      if (this.autoRefresh) {
        this.getCreditReport()
      }
    }, 30000)
  },
  destroyed() {
    if (this.refreshInterval) clearInterval(this.refreshInterval)
  },
  mounted() {
    this.getCreditReport()
  },
  methods: {
    formatDate(v) {
      if (!v || v === '-') return '-'
      return moment(v).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
    },
    buildDateTime(date, time) {
      // ถ้า time เป็น null ให้ fallback
      const t = time || '00:00'
      return `${date} ${t}:00`
    },
    async getCreditReport() {
      this.show = true

      const params = {
        page: this.currentPage,
        perPage: this.perPage,
        username: this.filters.username || '',
        type: this.filters.type || '',
        startDate: this.buildDateTime(this.filters.startDate, this.filters.startTime),
        endDate: this.buildDateTime(this.filters.endDate, this.filters.endTime),
      }

      try {
        // TODO: เปลี่ยน URL ตาม backend จริง ถ้าใช้ชื่ออื่น
        const { data: res } = await this.$http.get('/autopeer/creditreport', { params })

        const list = Array.isArray(res.data?.items || res.data) ? (res.data.items || res.data) : []
        this.items = list
        this.totalRows = Number(res.data?.total || res.total || list.length)

        // summary
        const s = res.data?.summary || res.summary || {}
        this.summary.creditBalance = Number(s.creditBalance || 0)
        this.summary.totalWithdraw = Number(s.totalWithdraw || 0)
        this.summary.totalDeposit = Number(s.totalDeposit || 0)
      } catch (err) {
        console.error(err)
        this.SwalError(err?.response?.data?.message || 'ไม่สามารถโหลดรายงาน Credit ได้')
      } finally {
        this.show = false
      }
    },
    onClear() {
      const today = moment().tz('Asia/Bangkok')
      this.filters.username = ''
      this.filters.type = ''
      this.filters.startDate = today.format('YYYY-MM-DD')
      this.filters.startTime = '00:00'
      this.filters.endDate = today.format('YYYY-MM-DD')
      this.filters.endTime = '23:59'
      this.currentPage = 1
      this.getCreditReport()
    },
    formatNumber(val) {
      const num = Number(val || 0)
      return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatDateTime(value) {
      if (!value || value === '-') return '-'
      return moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: '<h3 style="color:#141414">เกิดข้อผิดพลาด!</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        title: '<h3 style="color:#141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
  },
}
</script>

<style scoped>
.summary-box {
  border-radius: 4px;
  padding: 8px 12px;
}
.summary-title {
  font-size: 12px;
  color: #666;
}
.summary-value {
  font-size: 18px;
  font-weight: 600;
}
table {
  width: 100%;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
